module.exports = __webpack_public_path__ + "img/equipos-moviles-gal-3.1c31aa22.jpg";